import { ISummary } from '../../models/summary';

export const SUMMARY_SET = '[Summary] Set';

export interface SetSummary {
  type: typeof SUMMARY_SET;
  payload: { data: ISummary };
}

export const setSummary = (data: ISummary): SetSummary => {
  return {
    type: SUMMARY_SET,
    payload: { data },
  };
};

export type TransferType = SetSummary;